module.exports = __webpack_public_path__ + "assets/img/title_certificate.46188b15.jpg";